import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { ScheduleFormDrawer } from '@/features/schedules/components/schedule-form-drawer'

/**
 * Drawer de Agendar pagamento — FILHO do layout pathless `_pagar`, então abre
 * POR CIMA da lista (que fica montada no pai). Fechar volta para /pagamentos/pagar.
 */
export const Route = createFileRoute('/_authed/pagamentos/_pagar/agendar')({
  component: AgendarPagamento,
})

function AgendarPagamento() {
  const navigate = useNavigate()
  return (
    <ScheduleFormDrawer
      kind="payable"
      open
      onOpenChange={(aberto) => {
        if (!aberto) void navigate({ to: '/pagamentos/pagar' })
      }}
    />
  )
}
